import { useEventsControllerFindOneQuery } from '@app/api/eventsApi/events-api';
import { toEvent } from '@app/api/mappers';
import { TEvent } from '@app/models';
import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';

export const useEventQuery = (
  id?: string,
): ReturnType<typeof useEventsControllerFindOneQuery> & {
  data?: TEvent;
} => {
  const resp = useEventsControllerFindOneQuery({ shortId: id || '' });
  const data = useMemo<TEvent | undefined>(() => {
    return isEmpty(resp.data) ? undefined : toEvent(resp.data);
  }, [resp.data]);
  return { ...resp, data };
};
